// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"173b5007","455":"2dd6e9f4","490":"58d66f03","899":"fd067d1a"}[chunkId] + ".chunk.js";
};